/**
 * Sequência de emergência do PAEBM (GUPM-201) — passo-a-passo horizontal fiel ao
 * `.paebm-seq` do V8 (`renderMPAEBM`): cada passo é um círculo amarelo (ícone +
 * badge de índice) com título e descrição, e os passos são conectados por setas
 * amarelas (`→`). No mobile (<560px) vira coluna e as setas apontam para baixo.
 * As setas são decorativas (`aria-hidden`); o `data-testid` serve só ao teste.
 */
import { Fragment } from 'react';
import { SEQUENCIA_EMERGENCIA } from '../content';

export default function SequenciaEmergencia() {
  const ultimo = SEQUENCIA_EMERGENCIA.length - 1;
  // px-1 pt-2: o badge do índice protrai (-top-1/-right-1) e o overflow-x-auto
  // (que torna overflow-y=auto) cortaria a bolinha do número sem esse respiro.
  return (
    <div className="flex flex-col items-stretch gap-1 px-1 pt-2 min-[560px]:flex-row min-[560px]:items-start min-[560px]:overflow-x-auto">
      {SEQUENCIA_EMERGENCIA.map((p, i) => (
        <Fragment key={p.titulo}>
          <div className="flex flex-row items-center gap-2.5 text-left min-[560px]:min-w-[96px] min-[560px]:flex-1 min-[560px]:flex-col min-[560px]:items-center min-[560px]:gap-1.5 min-[560px]:text-center">
            <div className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-jf-yellow">
              <span className="text-lg" aria-hidden>{p.icone}</span>
              <span className="absolute -right-1 -top-1 flex h-[18px] w-[18px] items-center justify-center rounded-full border-[1.5px] border-jf-yellow bg-jf-bg text-[10px] font-extrabold text-jf-yellow">
                {i + 1}
              </span>
            </div>
            <div>
              <div className="text-[11.5px] font-extrabold leading-tight text-white">{p.titulo}</div>
              <div className="text-[9.5px] leading-tight text-jf-muted">{p.desc}</div>
            </div>
          </div>
          {i < ultimo && (
            <div
              data-testid="paebm-seq-arrow"
              aria-hidden
              className="shrink-0 rotate-90 self-start pl-[18px] text-lg leading-none text-jf-yellow opacity-70 min-[560px]:rotate-0 min-[560px]:self-center min-[560px]:pl-0 min-[560px]:pt-3"
            >
              →
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
}
